import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '@core/services/api';
import { CreateTicketPayload, Release, ServiceLevels, SupportStatus, Ticket } from '@model/support';
import { LengthAwarePaginator } from '@model/common/length-aware-paginator.model';
import { HttpQueryParams } from '@core/services/api/interfaces/query-params';
import { SupportPreferences, TicketsPage } from '@core/services/api/routes/tenancy/support.route';

@Injectable({ providedIn: 'root' })
export class SupportService {
  private readonly api = inject(ApiService);

  listar(params?: HttpQueryParams): Observable<TicketsPage> {
    return this.api.support.getTickets(params);
  }

  obter(id: string): Observable<Ticket> {
    return this.api.support.getTicket(id).pipe(map(response => response.data));
  }

  criar(payload: CreateTicketPayload, files: File[] = []): Observable<Ticket> {
    return this.api.support.createTicket(payload, files).pipe(map(response => response.data));
  }

  responder(id: string, body: string, files: File[]): Observable<Ticket> {
    return this.api.support.reply(id, body, files).pipe(map(response => response.data));
  }

  avaliar(id: string, rating: number, comment?: string | null): Observable<Ticket> {
    return this.api.support.rate(id, rating, comment).pipe(map(response => response.data));
  }

  novidades(params?: HttpQueryParams): Observable<LengthAwarePaginator<Release[]>> {
    return this.api.support.releases(params);
  }

  novidadesNaoVistas(): Observable<number> {
    return this.api.support.releasesUnseenCount().pipe(map(response => response.data.count));
  }

  marcarNovidadesVistas(): Observable<void> {
    return this.api.support.markReleasesSeen();
  }

  status(): Observable<SupportStatus> {
    return this.api.support.status().pipe(map(response => response.data));
  }

  niveisDeServico(): Observable<ServiceLevels> {
    return this.api.support.serviceLevels().pipe(map(response => response.data));
  }

  preferencias(): Observable<SupportPreferences> {
    return this.api.support.getPreferences().pipe(map(response => response.data));
  }

  atualizarPreferencias(emailHabilitado: boolean): Observable<SupportPreferences> {
    return this.api.support.updatePreferences({ email_enabled: emailHabilitado }).pipe(map(response => response.data));
  }

  baixarAnexo(id: string): Observable<Blob> {
    return this.api.support.downloadAttachment(id);
  }
}
